<template>
    <div class="top-nav">
        <img class="logo-img" src="@/assets/home_slices/logo@2x.png" alt="" @click="$router.push('/')">
        <div class="menu">
            <div @click="open('https://supply.knetgroup.com/')" class="login-btn">LOG IN</div>
            <div class="btn btn_hover" @click="open('https://vblek0j9spm.typeform.com/knetgroup?utm_source=xxxxx')">APPLY TO SELL</div>
        </div>
        <div class="phone-menu">
            <img class="img-menu" src="@/assets/home_slices/more@2x.png" alt="" @click="show = true">
            <div class="drop-down" v-if="show">
                <div @click="open('https://supply.knetgroup.com/')" class="login-btn">LOG IN</div>
                <div class="btn" @click="open('https://vblek0j9spm.typeform.com/knetgroup?utm_source=xxxxx')">APPLY TO SELL</div>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'NavPage',
    data() {
        return {
            show: false,
            menuOptions: [
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'FAQ', path: '/faq' },
            ]
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
        //点击任意位置关闭区域弹窗
        document.addEventListener('click', (e) => {
            //获取弹窗对象
            const userCon = document.getElementsByClassName('phone-menu')[0];
            const userCon1 = document.getElementsByClassName('drop-down')[0];
            const userCon2 = document.getElementsByClassName('img-menu')[0];

            //判断弹窗对象中是否包含点击对象
            if (!e.target.contains(userCon) && !e.target.contains(userCon1) && !e.target.contains(userCon2)) {
                this.show = false
            }
        })

    },
    methods: {
        open (url) {
            window.open(url, '_blank')
        },
        toPage(path) {
            this.$router.push(path, () => { }, () => { });
        },
        sendEmail () {
            const email = 'support@knetgroup.com';
            window.location.href = `mailto:${email}`;
        },
    }
}
</script>

<style lang="scss" scoped>
.top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 3.68%;
    width: 100%;
    background: #000000;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1999;
    box-sizing: border-box;

    .logo-img {
        width: 238px;
        height: 40px;
        cursor: pointer;
    }

    .menu {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        white-space: nowrap;
    }

    .btn {
        width: 198px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000000;
        background: #00DD3E;
        border-radius: 100px;
        font-family: GramatikaTrial;
        font-weight: 700;
        font-size: 18px;
        line-height: 21.6px;
        cursor: pointer;
    }

    .item {
        cursor: pointer;
        line-height: 19px;
    }

    .active {
        background-image: linear-gradient(134.99999999999986deg, #66F47F 0%, #93F466 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-family: GramatikaTrial;
    }

    .phone-menu {
        display: none;
        position: absolute;
        right: 10px;

        .img-menu {
            width: 24px;
            height: 24px;
            object-fit: contain;
        }

        .drop-down {
            position: absolute;
            right: 0;
            top: 32px;
            background: rgba(20, 22, 25, 0.5);
            border-radius: 2px;
            border: 1px solid rgba(255, 255, 255, 0.17);
            backdrop-filter: blur(10px);
            padding: 24px;
            display: flex;
            flex-direction: column;
            gap: 24px;
            align-items: flex-start;
            white-space: nowrap;
            /* 设置过渡效果 */
            transition: 1s;
        }


    }

}

@media (max-width: 576px) {

    .top-nav {
        padding: 16px 3.68%;
        height: 77px;

        .logo-img {
            width: 238px;
            height: 42px;
        }

        .menu {
            display: none;
        }

        .phone-menu {
            display: block;
            width: 24px;
            height: 24px;
            object-fit: contain;
        }
    }
}

.login-btn {
    color: #00DD3E;
    position: relative;
    width: 198px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    font-family: GramatikaTrial;
    font-weight: 700;
    font-size: 18px;
    line-height: 21.6px;
    cursor: pointer;
}
.login-btn:hover {
    color: #38ec27;
    background: linear-gradient(225deg, #45454554 0%, #2222226e 100%);
}

.login-btn::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 2px;
    box-sizing: border-box;
    border-radius: 100px;
    background: linear-gradient(225deg, #66F47F 0%, #93F466 100%);
    /* 随便定义一个颜色 */
    --mask-bg: linear-gradient(red, red);
    --mask-clip: content-box, padding-box;
    -webkit-mask-image: var(--mask-bg), var(--mask-bg);
    -webkit-mask-clip: var(--mask-clip);
    /* exclude排除，只显示不重合的地方,Firefox支持4个属性 */
    mask-composite: exclude;
    /* 只显示下方遮罩，重合的地方不显示 */
    -webkit-mask-composite: destination-out;
}
</style>